import React from "react";
import { Container, Typography, Button, Box, Grid2, Card, CardContent, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { motion } from "framer-motion";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import LinkIcon from "@mui/icons-material/Link";
import EventIcon from "@mui/icons-material/Event";

const tarifas = [
    {
        title: "🇬🇹 Nacional",
        price: [
            { date: "Hasta el 30-06-2025", amount: "$525" },
            { date: "Hasta el 31-08-2025", amount: "$575" },
            { date: "Hasta el día del evento", amount: "$650" }
        ],
        color: "#272948",
    },
    {
        title: "🌎 Extranjero",
        price: [
            { date: "Hasta el 30-06-2025", amount: "$675" },
            { date: "Hasta el 31-08-2025", amount: "$750" },
            { date: "Hasta el día del evento", amount: "$850" }
        ],
        color: "#272948",
    },
    {
        title: "👥 Acompañante",
        price: [
            { date: "Hasta el 30-06-2025", amount: "$200" },
            { date: "Hasta el 31-08-2025", amount: "$200" },
            { date: "Hasta el día del evento", amount: "$200" }
        ],
        color: "#272948",
    },
];

const Tarifas = () => {
    return (
        <Box
            sx={{
                color: "white",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: 4,
            }}
        >
            <Container maxWidth>
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 1 }}
                >
                    <Typography color='#1f3f5d' variant="h2" fontWeight="bold" gutterBottom>
                        Tarifas y Entradas
                    </Typography>
                    <Typography color='#1f3f5d' variant="h5" sx={{ marginBottom: 2 }}>
                        Consulta las tarifas según la fecha de inscripción.
                    </Typography>
                </motion.div>

                <Grid2 container spacing={3} justifyContent="center">
                    {tarifas.map((tarifa, index) => (
                        <Grid2 size={{ xs: 12, md: 6, lg: 4 }} key={index}>
                            <motion.div
                                whileHover={{ scale: 1.05 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                initial={{ opacity: 0, y: 50 }}
                                viewport={{ once: false, amount: 0.3 }}
                                transition={{ duration: 0.8 }}
                            >
                                <Card sx={{ backgroundColor: tarifa.color, color: "white", borderRadius: 2, boxShadow: 3 }}>
                                    <CardContent>
                                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                                            {tarifa.title}
                                        </Typography>
                                        <List>
                                            {tarifa.price.map((p, i) => (
                                                <ListItem key={i}>
                                                    <ListItemIcon>
                                                        <EventIcon sx={{ color: "white" }} />
                                                    </ListItemIcon>
                                                    <ListItemText primary={`${p.date}: ${p.amount}`} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </CardContent>
                                </Card>
                            </motion.div>
                        </Grid2>
                    ))}
                </Grid2>

                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.8 }}
                >
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: "#f2b440", color: "white", marginTop: 4 }}
                        startIcon={<LinkIcon />}
                        href="https://escuela-bancaria.s3.us-east-2.amazonaws.com/2c8f40c4-985f-48ac-a895-0fb83fffbb94.pdf"
                        target="_blank"
                    >
                        Más información
                    </Button>
                </motion.div>
            </Container>
        </Box>
    );
};

export default Tarifas;
